import { EMPTY, Observable, from } from 'rxjs';
import { expand } from 'rxjs/operators';

export type BaseProps = { limit: number; offset?: number };

export class Postgres {
  static bufferedQuery$<T extends object, Props extends BaseProps>(
    query: (vars: Props) => Promise<T[]>,
    queryProps: Props,
    initialRecordOffset?: number,
    recordLimit?: number
  ): Observable<T[]> {
    const queryFn = (vars: Props, lastRecordOffset?: number): Promise<T[]> => {
      if (!lastRecordOffset) {
        return query(vars);
      }
      return query({ ...vars, offset: lastRecordOffset });
    };

    let totalRecordCount = 0;

    return from(queryFn(queryProps, initialRecordOffset)).pipe(
      expand((data) => {
        totalRecordCount += data.length;
        const hasReachedLimit = recordLimit
          ? totalRecordCount >= recordLimit
          : false;
        if (hasReachedLimit) {
          return EMPTY;
        }

        return data.length >= queryProps.limit
          ? from(queryFn(queryProps, totalRecordCount))
          : EMPTY;
      })
    );
  }
}
